import React from 'react';
import PropTypes from 'prop-types';

import { useOrderData } from '../../../../hooks/useOrderData';
import { useCheckoutData } from '../../../../hooks/useCheckoutData';
import { BillingSummary, PaymentDetails } from './components';
import { Box } from 'core/ui/atoms';

import Loading from 'core/ui/components/Loading';
import { isLoading } from 'core/api/loadingHelpers';

const Checkout = ({ userSwapsForDeliveryDay }) => {
  const { deliveryDays } = useOrderData();
  const { loading, error, userSwapBillingSummary } = useCheckoutData();

  if (isLoading(loading, userSwapBillingSummary, error)) {
    return <Loading />;
  }

  return (
    <Box>
      <BillingSummary billingSummary={userSwapBillingSummary} />
      <PaymentDetails
        deliveryDays={deliveryDays}
        userSwapsForDeliveryDay={userSwapsForDeliveryDay}
      />
    </Box>
  );
};

Checkout.propTypes = {
  userSwapsForDeliveryDay: PropTypes.array,
};

export default Checkout;
